import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChecklistIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.785 1.3a.75.75 0 0 1-.01 1.061L4.374 4.72a1.25 1.25 0 0 1-1.747.005l-1.4-1.36a.75.75 0 0 1 1.046-1.076l1.224 1.19L5.725 1.29a.75.75 0 0 1 1.06.01ZM9 2.826a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75ZM6.785 6.3a.75.75 0 0 1-.01 1.061L4.374 9.72a1.25 1.25 0 0 1-1.747.005l-1.4-1.36a.75.75 0 0 1 1.046-1.076l1.224 1.19L5.725 6.29a.75.75 0 0 1 1.06.01ZM9 7.826a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75ZM6.775 12.361a.75.75 0 1 0-1.05-1.07l-2.228 2.187-1.224-1.19a.75.75 0 0 0-1.046 1.076l1.4 1.36a1.25 1.25 0 0 0 1.747-.005l2.401-2.358ZM9.75 12.076a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
		></path>
	</svg>
))
